import semver from 'semver';

import { MyAccountCoreConfig } from '../interfaces/ClientInfo';
import { qsConfigs } from './helpers';

type SdkPlatform = 'js' | 'ios' | 'android';

const condition: Record<SdkPlatform, string> = {
  js: '2.0.0-0',
  ios: '6.0.0-0',
  android: '6.0.0-0'
};

const sdkValidators = (platform: SdkPlatform, version: string): boolean => {
  const minVersion = condition[platform];
  if (!minVersion) {
    return false;
  }
  return semver.gte(version, minVersion);
};

export function isMagicLinkEnabled(
  myAccountConfig?: MyAccountCoreConfig | null
): boolean {
  const { enableMagicLink = false } = myAccountConfig || {};
  const { sdkPlatform, sdkVersion, authnMethod } = qsConfigs() as {
    sdkPlatform: SdkPlatform;
    sdkVersion: string;
    authnMethod: string[] | string;
  };

  if (authnMethod === 'passwordless') return true;
  if (Array.isArray(authnMethod) && authnMethod.includes('passwordless')) {
    return true;
  }
  if (!enableMagicLink) return false;

  // run directly on browser without sdk
  // TODO: flip to true when magic link is ready for moneytree only guests
  if (!sdkPlatform || !sdkVersion) return false;

  let valid = false;

  try {
    valid = sdkValidators(sdkPlatform, sdkVersion);
  } catch (error) {
    // istanbul ignore next
    // only show warning in non test environment
    if (window.navigator.userAgent.indexOf('jsdom') === -1) {
      console.warn('Magic Link', (error as Error).message);
    }
  }

  return valid;
}

export function isOtpLoginEnabled(
  myAccountConfig?: MyAccountCoreConfig | null
): boolean {
  const { enableOtpLogin } = myAccountConfig || {};
  if (enableOtpLogin) return true;

  const { authnMethod } = qsConfigs() as { authnMethod: string[] | string };
  if (authnMethod === 'otp') return true;
  if (Array.isArray(authnMethod) && authnMethod.includes('otp')) return true;

  return false;
}

export function decideEmailLoginMethod(
  myAccountConfig?: MyAccountCoreConfig | null
): 'otp' | 'magicLink' | 'none' {
  if (isOtpLoginEnabled(myAccountConfig)) return 'otp';
  if (isMagicLinkEnabled(myAccountConfig)) return 'magicLink';

  return 'none';
}
